module.exports = __webpack_public_path__ + "static/media/ring.c6f68203.mp3";